import { useReducer } from 'react';
import { DEFAULT_STATE } from './constants';
import reducer from './reducer';

export default function useEditorStateReducer() {
  return useReducer(reducer, DEFAULT_STATE);
}
